export default async function commitPendingInput() {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
  await new Promise((resolve) => setTimeout(resolve, 0));
}
